(() => {
  const parseLocal = value => {
    const match = String(value).trim().match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?$/);
    if (!match) return NaN;
    const [, y, mo, d, h, mi, sec = '00'] = match;
    const check = new Date(Date.UTC(+y, +mo - 1, +d));
    if (check.getUTCFullYear() !== +y || check.getUTCMonth() !== +mo - 1 || check.getUTCDate() !== +d || +h > 23 || +mi > 59 || +sec > 59) return NaN;
    return new Date(+y, +mo - 1, +d, +h, +mi, +sec).getTime();
  };
  const wallTime = timestamp => {
    const d = new Date(timestamp);
    return Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds());
  };
  const shiftLocalDays = (timestamp, days) => {
    const d = new Date(timestamp);
    d.setDate(d.getDate() + days);
    return d.getTime();
  };
  const phaseAt = (now, start, end, period) => {
    const duration = wallTime(end) - wallTime(start);
    if (![now, start, end].every(Number.isFinite) || end <= start || (period !== 0 && (!Number.isFinite(period) || period < duration))) return { phase: 'invalid' };
    if (now < start) return { phase: 'upcoming', target: start };
    if (!period) return now < end ? { phase: 'active', target: end } : { phase: 'ended' };
    const days = period / 86400000;
    // Repeat by local calendar days so local start/end times survive DST changes.
    let cycle = Math.max(0, Math.floor((wallTime(now) - wallTime(start)) / period));
    while (cycle > 0 && now < shiftLocalDays(start, cycle * days)) cycle--;
    while (now >= shiftLocalDays(start, (cycle + 1) * days)) cycle++;
    const cycleEnd = shiftLocalDays(end, cycle * days);
    return now < cycleEnd ? { phase: 'active', target: cycleEnd } : { phase: 'upcoming', target: shiftLocalDays(start, (cycle + 1) * days) };
  };
  if (customElements.get('scheduled-countdown')) return;
  customElements.define('scheduled-countdown', class extends HTMLElement {
    connectedCallback() {
      this.start = parseLocal(this.dataset.start);
      this.end = parseLocal(this.dataset.end);
      const days = Number(this.dataset.period);
      this.period = this.dataset.mode === 'repeat' ? (Number.isInteger(days) && days > 0 ? days * 86400000 : NaN) : 0;
      this.tick = this.tick.bind(this);
      this.onVisibility = () => { if (!document.hidden) this.tick(); };
      this.tick();
      if (this.dataset.enabled === 'true' && phaseAt(Date.now(), this.start, this.end, this.period).phase !== 'invalid') {
        this.interval = setInterval(this.tick, 1000);
        document.addEventListener('visibilitychange', this.onVisibility);
      }
    }
    disconnectedCallback() {
      clearInterval(this.interval);
      document.removeEventListener('visibilitychange', this.onVisibility);
    }
    tick() {
      const now = Date.now();
      const state = phaseAt(now, this.start, this.end, this.period);
      const editor = this.dataset.editor === 'true';
      const disabled = this.dataset.enabled !== 'true';
      const invalid = state.phase === 'invalid';
      const notice = this.querySelector('[data-schedule-notice]');
      const content = this.querySelector('[data-schedule-content]');
      notice.hidden = !(editor && (invalid || disabled));
      content.hidden = invalid || disabled;
      this.hidden = !editor && (invalid || disabled || (state.phase === 'upcoming' && this.dataset.upcoming !== 'true') || (state.phase === 'ended' && this.dataset.hideEnded === 'true'));
      if (invalid || disabled) return;
      const label = this.querySelector('[data-phase-label]');
      const labelText = this.dataset[state.phase + 'Label'] || '';
      if (label.textContent !== labelText) label.textContent = labelText;
      const clock = this.querySelector('[data-clock]');
      clock.hidden = state.phase === 'ended';
      if (clock.hidden) return;
      let remaining = Math.max(0, Math.ceil((state.target - now) / 1000));
      const parts = [Math.floor(remaining / 86400), Math.floor(remaining % 86400 / 3600), Math.floor(remaining % 3600 / 60), remaining % 60];
      this.querySelectorAll('[data-time-part]').forEach((node, i) => {
        const value = String(parts[i]).padStart(2, '0');
        if (node.textContent !== value) node.textContent = value;
      });
    }
  });
})();
